import { useState, type FormEvent } from 'react';

const TOKEN_KEY = 'voicer_ws_token';

export function sessionTokenKey(): string {
  return TOKEN_KEY;
}

export async function fetchLoginRequired(): Promise<boolean> {
  try {
    const res = await fetch('/api/auth/status');
    if (!res.ok) return false;
    const body = (await res.json()) as { required?: boolean };
    return Boolean(body.required);
  } catch {
    return false;
  }
}

export async function validateSessionToken(token: string): Promise<boolean> {
  if (!token) return false;
  try {
    const res = await fetch('/api/auth/check', {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.ok;
  } catch {
    return false;
  }
}

export async function loginWithPassword(password: string): Promise<string> {
  const res = await fetch('/api/auth/login', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ password }),
  });
  const body = (await res.json().catch(() => ({}))) as { ok?: boolean; token?: string; error?: string };
  if (!res.ok || !body.ok || typeof body.token !== 'string' || !body.token) {
    throw new Error(body.error || 'invalid password');
  }
  return body.token;
}

export function SplashGate(props: Readonly<{ onUnlocked: (token: string) => void }>): React.ReactNode {
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: FormEvent): Promise<void> => {
    e.preventDefault();
    if (busy) return;
    setBusy(true);
    setError(null);
    try {
      const token = await loginWithPassword(password);
      sessionStorage.setItem(TOKEN_KEY, token);
      props.onUnlocked(token);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'invalid password');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="splash">
      <form className="splash-card" onSubmit={(e) => void submit(e)}>
        <div className="splash-brand">
          LegalAI: Voice <span className="sub">legal case workspace</span>
        </div>
        <p className="splash-hint">Enter the site password to continue.</p>
        <label className="splash-label">
          Password
          <input
            type="password"
            autoFocus
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            disabled={busy}
          />
        </label>
        {error ? (
          <p className="splash-error" role="alert">
            {error}
          </p>
        ) : null}
        <button type="submit" className="primary splash-submit" disabled={busy || !password}>
          {busy ? 'Checking…' : 'Continue'}
        </button>
      </form>
    </div>
  );
}
